import 'htmx.org'
import arrowLine from 'arrow-line'

function bindAccordionEvents () {
  document.querySelectorAll('.ams-accordion__button').forEach((button) => {
    button.addEventListener('click', function () {
      // Toggle aria-expanded attribute
      const isExpanded = this.getAttribute('aria-expanded') === 'true'
      this.setAttribute('aria-expanded', !isExpanded)

      // Get the associated panel
      const panelId = this.getAttribute('aria-controls')
      const panel = document.getElementById(panelId)

      // Toggle panel visibility
      panel.classList.toggle('ams-accordion__panel--expanded')
      drawArrows()
    })
  })
}

// Re-draw arrows after HTMX settles, dom content loaded and window resize
document.body.addEventListener('htmx:afterSettle', () => {
  resizeArrowCanvas()
  drawArrows()
  bindAccordionEvents()
})
window.addEventListener('resize', () => {
  resizeArrowCanvas()
  drawArrows()
})

const arrowManager = (() => {
  let arrows = []

  return {
    clear () {
      arrows.forEach(arrow => arrow.remove())
      arrows = []
    },
    add (arrow) {
      arrows.push(arrow)
    }
  }
})()

function resizeArrowCanvas () {
  const svgCanvas = document.getElementById('__arrowLineInternal-svg-canvas')
  if (!svgCanvas) {
    console.warn('Arrow canvas not found')
    return
  }
  svgCanvas.setAttribute('width', document.body.clientWidth)
  svgCanvas.setAttribute('height', document.body.clientHeight)
}

function drawArrows () {
  arrowManager.clear()

  document.querySelectorAll('[data-arrow]').forEach((el) => {
    const fromId = el.getAttribute('from')
    const toId = el.getAttribute('to')
    const color = el.getAttribute('color') || '#296506'
    const style = el.getAttribute('arrow-style') || 'solid'
    if (fromId && toId) {
      const fromEl = document.getElementById(fromId)
      const toEl = document.getElementById(toId)
      if (!fromEl || !toEl) {
        console.warn(`Arrow elements not found: from=${fromId}, to=${toId}`)
        return
      }
      try {
        const arrow = arrowLine('#' + fromId, '#' + toId, {
          color,
          curvature: 1,
          style,
          thickness: 2,
          endpoint: { type: 'arrowHead' }
        })
        arrowManager.add(arrow)
      } catch (error) {
        console.error('Failed to create arrow:', error)
      }
    }
  })
}
